import { render, staticRenderFns } from "./exclusiveClients.vue?vue&type=template&id=ae0fb0e4&scoped=true&"
import script from "./exclusiveClients.vue?vue&type=script&lang=js&"
export * from "./exclusiveClients.vue?vue&type=script&lang=js&"
import style0 from "./exclusiveClients.vue?vue&type=style&index=0&id=ae0fb0e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae0fb0e4",
  null
  
)

export default component.exports